<p-panelmenu
  #collapsedSideMenu
  [model]="routes"
>
  <ng-template
    #item
    let-item
  >
    @if (item.icon) {
      <a
        [routerLink]="getRouterLink(item)"
        [title]="item.label"
        routerLinkActive="active-menu-item"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <nsp-icon [name]="item.icon" />
      </a>
    }
  </ng-template>
</p-panelmenu>
